// extracted by mini-css-extract-plugin
export default {"mCard":"RC-z","image":"SC-z","imageNoBackground":"TC-z","imageHasCategory":"UC-z","fullWidth":"VC-z"};